/**
 * One random id per PAGE LOAD, sent on every stream so the backend can enforce
 * "one live screen per account" (anti login-sharing).
 *
 * Deliberately NOT persisted to localStorage/sessionStorage: two tabs (or a
 * duplicated tab) sharing an id would count as ONE screen and let two people
 * share a login. A future multi-ticker screen sends this same id on each of its
 * streams, so it never bumps itself — see
 * docs/superpowers/specs/2026-10-08-deltatape-one-screen-per-account-design.md.
 */
export const SCREEN_ID: string = makeScreenId(crypto);

/** `randomUUID` needs Safari 15.4+ / a secure context; fall back to random hex so the app still loads. */
export function makeScreenId(c: Pick<Crypto, "getRandomValues"> & { randomUUID?: () => string }): string {
  if (typeof c.randomUUID === "function") return c.randomUUID();
  return Array.from(c.getRandomValues(new Uint8Array(16)), (b) => b.toString(16).padStart(2, "0")).join("");
}
